export const capitalize = (str) => {
  const lowerCaseStr = str.toLowerCase();
  return lowerCaseStr
    .toLowerCase()
    .split(" ")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const replaceString = (str, replaceObj) => {
  for (let key in replaceObj) {
    if (replaceObj.hasOwnProperty(key)) {
      str = str.replace(`{${key}}`, replaceObj[key]);
    }
  }
  return str;
};

export const getHashtag = (bride, groom) => {
  return `#${groom?.split(" ")[0]}GoesTo${bride?.split(" ")[0]}`;
};

export const getBrideGroomNameFromURL = () => {
  const pathname = window.location.pathname;
  const search = window.location.search;

  if (search.includes("?theme=")) {
    return {
      brideName: "Pratik",
      groomName: "Astha",
    };
  }
  let path = pathname.replace(/^\/|\/$/g, "");

  // Remove optional "preview/" prefix
  if (path.startsWith("preview/")) {
    path = path.replace("preview/", "");
  }

  const match = path.match(
    /^([a-z]+?)(?:-weds-|-and-|-|weds|and)([a-z]+)(?:-|$)*/i
  );

  if (!match) {
    return {
      brideName: "",
      groomName: "",
    };
  }

  return {
    brideName: capitalize(match[1]),
    groomName: capitalize(match[2]),
  };
};